import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, image, noindex, jsonLd }) {
  useEffect(() => {
    const full = title ? (title.includes("Shivam Cine Core") ? title : `${title} | Shivam Cine Core`) : "Shivam Cine Core";
    document.title = full;
    const desc = description || "Movie recommendations, explained videos, genuine community ratings and verified legal streaming links.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", image || "");
    setMeta("property", "og:url", window.location.origin + window.location.pathname);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = window.location.origin + window.location.pathname;
    let s = document.getElementById("jsonld");
    if (jsonLd) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "jsonld";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    } else if (s) s.remove();
  }, [title, description, image, noindex, jsonLd]);
}
